import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import HomePage from '../../pages/homepage'
import { UserInviteVerify } from './components/UserInviteVerify'
import { EmailVerifyWelcomePage } from './components/EmailVerifyWelcomePage'

const AuthPage = () => (
  <Routes>
    <Route path='login' element={<Login />} />
    <Route path='login/:id' element={<UserInviteVerify />} />
    <Route path='account-verify/:id' element={<EmailVerifyWelcomePage />} />
    <Route path='forgot-password' element={<ForgotPassword />} />
    <Route element={<AuthLayout />}>
      <Route path='registration' element={<Registration />} />
    </Route>
    <Route index element={<HomePage />} />
  </Routes>
)

export {AuthPage}
